import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle, X } from "lucide-react";
import { trackContact } from "../utils/tracking";

const WHATSAPP_PHONE = "919108818369";

const PAGE_MESSAGES = {
  "/consultation": [
    { label: "Book a Consultation", text: "Hi! I'd like to book a consultation call with Fitly India." },
    { label: "Ask About Fees", text: "Hi! Can you tell me about your consultation fees and what's included?" },
    { label: "General Query", text: "Hi! I have a question before booking a consultation." },
  ],
  "/programs/elite": [
    { label: "Enquire About Elite", text: "Hi! I'm interested in the Fitly Elite program. Can you share more details?" },
    { label: "Which Duration Suits Me?", text: "Hi! I'm considering Fitly Elite but unsure whether to pick the 1, 3, or 6-month plan. Can you help?" },
    { label: "Couples Track Info", text: "Hi! My partner and I are interested in the Fitly Elite Couples Track. How does it work?" },
  ],
  "/programs/premium-plus": [
    { label: "Enquire About Premium Plus", text: "Hi! I'm interested in the Fitly Premium Plus — Conception to Motherhood program." },
    { label: "What's Included?", text: "Hi! Can you walk me through what's included in the Premium Plus program?" },
    { label: "Book a Consultation First", text: "Hi! I'd like to book a consultation call before enrolling in Premium Plus." },
  ],
  "/pcos-consultation": [
    { label: "PCOS Support", text: "Hi! I'm looking for help managing my PCOS through nutrition. Can you tell me about your programs?" },
    { label: "Book PCOS Consultation", text: "Hi! I'd like to book a consultation for PCOS management." },
  ],
  "/couple-fertility-nutrition": [
    { label: "Couples Program Info", text: "Hi! My partner and I are interested in the couples fertility nutrition program." },
    { label: "Book a Consultation", text: "Hi! We'd like to book a couples consultation with Fitly India." },
  ],
  "/male-fertility-nutrition": [
    { label: "Male Fertility Support", text: "Hi! I'm looking for help with male fertility nutrition. Can you share details?" },
    { label: "Book a Consultation", text: "Hi! I'd like to book a consultation for male fertility support." },
  ],
  "/success-stories": [
    { label: "I Want Similar Results", text: "Hi! I've been reading your success stories and I'd love to discuss how Fitly can help me too." },
    { label: "Which Program Suits Me?", text: "Hi! I've seen your client results. Can you help me pick the right program for my condition?" },
    { label: "Book a Consultation", text: "Hi! I'd like to book a consultation call after reading your success stories." },
  ],
  "/female-fertility-nutrition": [
    { label: "Female Fertility Support", text: "Hi! I'm looking for help with fertility nutrition. Can you share details?" },
    { label: "Book a Consultation", text: "Hi! I'd like to book a consultation for fertility support." },
  ],
};

const DEFAULT_MESSAGES = [
  { label: "Book a Consultation", text: "Hi! I'd like to book a consultation with Fitly India." },
  { label: "Program Enquiry", text: "Hi! I'd like to know more about your fertility programs — Fitly Elite and Premium Plus." },
  { label: "General Query", text: "Hi! I have a question about Fitly India's services." },
];

const WhatsAppButton = () => {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  const messages = PAGE_MESSAGES[location.pathname] || DEFAULT_MESSAGES;

  return (
    <div className="fixed bottom-6 right-6 z-50" data-testid="whatsapp-fab">
      {open && (
        <div className="absolute bottom-16 right-0 w-72 bg-white rounded-2xl shadow-2xl border border-emerald_deep/10 overflow-hidden mb-2"
          data-testid="whatsapp-menu">
          <div className="bg-emerald_deep px-5 py-4 flex items-center justify-between">
            <div>
              <p className="text-bone text-sm font-semibold">Fitly India</p>
              <p className="text-bone/60 text-xs">Typically replies within minutes</p>
            </div>
            <button onClick={() => setOpen(false)} className="text-bone/60 hover:text-bone">
              <X size={16} />
            </button>
          </div>
          <div className="p-3 space-y-2">
            {messages.map((m) => (
              <a key={m.label} href={`https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(m.text)}`}
                target="_blank" rel="noopener noreferrer" data-testid={`wa-option-${m.label.toLowerCase().replace(/\s/g, '-')}`}
                onClick={() => trackContact('whatsapp')}
                className="block w-full text-left px-4 py-3 rounded-xl text-sm text-emerald_deep bg-bone hover:bg-emerald_deep/5 transition-colors border border-emerald_deep/5">
                {m.label}
              </a>
            ))}
          </div>
        </div>
      )}
      <button onClick={() => setOpen(!open)} data-testid="whatsapp-fab-btn"
        className="w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg hover:shadow-xl hover:scale-105 transition-all flex items-center justify-center">
        <MessageCircle size={24} fill="white" strokeWidth={0} />
      </button>
    </div>
  );
};

export default WhatsAppButton;
